import gql from "graphql-tag";

export default gql`
  mutation($site_id: ID!) {
    setDefaultFuelStore(site_id: $site_id)
  }
`;
